import { ApplicantAuthGuardService } from './guards/applicant-auth-guard.service';
import { EmployeeAuthGuardService } from './guards/employee-auth-guard.service';
import { AuthService } from './services/auth/auth.service';

export const MAIN_SERVICES = [
  AuthService,
  ApplicantAuthGuardService,
  EmployeeAuthGuardService,
];
